import { render, staticRenderFns } from "./o-footer.vue?vue&type=template&id=a08548c4&"
import script from "./o-footer.vue?vue&type=script&lang=js&"
export * from "./o-footer.vue?vue&type=script&lang=js&"
import style0 from "./o-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports